import { makeAutoObservable } from "mobx";
import { useMemo } from "react";

export interface IInputValidationState {
    id: string;
    isValid: boolean;
}

export interface IValidationGroup {
    shouldRevalidate: number;
    update(state: IInputValidationState): void;
    delete(id: string): void;
    isValid(): boolean;
    validate(): void;
}

class ValidationGroup implements IValidationGroup {

    private _map: Map<string, IInputValidationState>;
    private _revalidationAttempts = 0;

    constructor() {
        this._map = new Map<string, IInputValidationState>();
        this.update.bind(this);
        this.isValid.bind(this);
        this.delete.bind(this);
        makeAutoObservable(this, {}, { autoBind: true });
    }

    public update(state: IInputValidationState): void {
        this._map.set(state.id, state);
    }

    public delete(id: string): void {
        this._map.delete(id);
    }

    public isValid(): boolean {
        let isValid = true;
        
        this._map.forEach(inpState => {
            isValid = isValid && inpState.isValid;
        });

        return isValid;
    }

    public validate(): void {
        this._revalidationAttempts++;
    }

    get shouldRevalidate() {
        return this._revalidationAttempts;
    }
}


const useValidationGroup = (): IValidationGroup => {
    return useMemo(() => {
        return new ValidationGroup();
    }, []);
}

export default useValidationGroup;


